export const saveMessage = 'Are you sure you want to save?'
export const deleteMessage = 'Are you sure you want to delete?'
